import { Resource } from 'src/app/global/domain/resource.model';

export class AtividadeComercial extends Resource {
  descricao: string;
}
